import { useAuth } from '../services/AuthManager/AuthManager.react';
import { useRedirectToStartPageDecorator } from './useRedirectToStartPageDecorator';

export const useSignOutWithRedirect = () => {
  const { signOut } = useAuth();
  const { withRedirectToStartPage } = useRedirectToStartPageDecorator();

  return { signOut: withRedirectToStartPage(signOut) };
};
